import {expertPaymentConstants} from "_constants";

const INITIAL_STATE = {
    expertPayments: {
        data: {},
        loading: false,
        error: null,
    },

    selectedExperts: {}
};

export function expertPaymentReducer(state = INITIAL_STATE, action) {
    switch (action.type) {

        case expertPaymentConstants.LIST_EXPERT_PAYMENT_REQUEST:
            return {...state, expertPayments: {...state.expertPayments, loading: true, error: null}};
        case expertPaymentConstants.LIST_EXPERT_PAYMENT_SUCCESS:
            return {...state, expertPayments: {data: action.payload, loading: false, error: null}};
        case expertPaymentConstants.LIST_EXPERT_PAYMENT_FAILURE:
            return {...state, expertPayments: {...state.expertPayments, loading: false, error: action.error}};

        case expertPaymentConstants.CLEAR_EXPERT_BALANCE_REQUEST:
            return {...state, expertPayments: {...state.expertPayments, loading: true, error: null}};
        case expertPaymentConstants.CLEAR_EXPERT_BALANCE_SUCCESS:
            return {...state, expertPayments: updateExpertPaymentList(state.expertPayments, action.payload)};
        case expertPaymentConstants.CLEAR_EXPERT_BALANCE_FAILURE:
            return {...state, expertPayments: {...state.expertPayments, loading: false, error: action.error}};

        default:
            return state
    }
}

function updateExpertPaymentList(currentExpertPayments, updatedData) {
    if (!currentExpertPayments?.data?.experts) return currentExpertPayments;

    const currentExperts = currentExpertPayments.data.experts;
    const updatedExperts = Array.isArray(updatedData.experts) ? updatedData.experts : [];

    const mergedExperts = currentExperts.map(expert => {
        const updated = updatedExperts.find(u => u.user.id === expert.user.id);
        return updated || expert;
    });

    return {
        ...currentExpertPayments,
        data: {
            ...currentExpertPayments.data,
            experts: mergedExperts,
            notFound: updatedData.notFound,
            success: updatedData.success
        },
        loading: false,
        error: null
    };
}




